import {
	desktopSize,
	mobileSize,
} from '@components/filmstrip-carousel/constants';
import { MEDIA_QUERY_STATES } from '@constants/media-query';
import { useMedia } from '@tkww/orion-web-app-kernel';
import { useMemo } from 'react';

export const useSlideWidth = () => {
	const desktopMedia = useMedia('@desktop');

	return useMemo(() => {
		const isDesktop = desktopMedia === MEDIA_QUERY_STATES.matched;
		return isDesktop ? desktopSize : mobileSize;
	}, [desktopMedia]);
};
